import { useCallback, useEffect, useState, useRef } from 'react';
// @ts-ignore
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import { Link, useNavigate } from 'react-router-dom';
import { postLounge, postLoungeWdw } from '../redux/lounges/slice';
import Modal from 'react-modal';
import { useAppDispatch } from '../redux/store';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectLounges } from '../redux/lounges/selectors';
import CircularProgress from '@mui/material/CircularProgress';
import { isMobile } from 'react-device-detect';
import Post from '../assets/img/h-p.png';
import { getValue } from '@testing-library/user-event/dist/utils';
import { BiWindows } from 'react-icons/bi';
import { RichTextEditor, DEFAULT_CONTROLS  } from '@mantine/rte';
import {GET_BASE_URL, GET_BASE_URL_IMAGE, LAND_CHAT_IMAGE_DIR} from "../constants";
import {UploadImage} from "../utils/uploadImage";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  buildPostedPostFeedHref,
} from '../utils/postSubmit';
import { writePendingPost } from './PendingPostNotice';
import { isMouseWaitAdminLogin } from '../utils/mwIntelligence';
import { hasPostableLoungeContent } from '../utils/loungePost';


// import ProgressBar from "@ramonak/react-progress-bar";
type LoungeBoxPropsType = {
  setVisible: any;
  isVisible: any;
  onCloseMenu: any;
};

Modal.setAppElement('#root');
const DRAFT_STORAGE_KEY = 'mw_lounge_post_draft_v1';
const PUBLISHED_DRAFT_STORAGE_KEY = 'mw_lounge_post_published_draft_v1';

function isRichTextEmpty(value: string) {
  return !value || value.trim() === '<p><br></p>';
}

function normalizeUrl(value: string) {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (/^(https?:|mailto:|tel:)/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

function normalizeDraftMessage(value: string) {
  return String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function getDraftMessage(draft: any) {
  return draft?.advancedpost ? draft?.richtextvalue || '' : draft?.text || '';
}

// Modal positioning only — the visual look (background, borders, radius,
// shadow, padding) is handled by CSS via the `mw-post-modal` className so it
// can adapt to the modern theme and to mobile / iOS webview.
const customStyles = {
  content: {
    position: 'fixed' as const,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: 'min(560px, calc(100% - 32px))',
    maxHeight: 'calc(100vh - 32px)',
    padding: 0,
  },
  overlay: {
    backgroundColor: 'rgba(7, 10, 26, 0.46)',
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
    zIndex: 10010,
  },
};

/**
 * upload image for richeditor
 * @param file
 */
const handleImageUpload = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      UploadImage(file)
          .then((result) => resolve(LAND_CHAT_IMAGE_DIR + result.data.c_file_name ))
          .catch(() => reject(new Error('Upload failed')));
    });

export const LoungeBox: React.FC<LoungeBoxPropsType> = ({
  setVisible,
  isVisible,
  onCloseMenu
}) => {
  const [modalIsOpen, setIsOpen] = useState(isVisible);

  const [land, setLand] = useState<number | string>('7');

  const [file, setFile] = useState<File | ''>('');
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string>('');
  const loungland = localStorage.getItem('loungeland');
  const club333 = localStorage.getItem('club333');
  const [text, setText] = useState('');

  let subtitle: any;
  function openModal() {
    onCloseMenu();
    setIsOpen(true);
  }

  const scrollLoungeToTop = useCallback(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document
      .querySelectorAll<HTMLElement>(
        '.mw-lounge-modern, .mid-sec, .mid-card-sec, .bm-menu-wrap, main'
      )
      .forEach((node) => {
        node.scrollTop = 0;
      });
  }, []);

  let navigate = useNavigate();

  const { register, setValue, getValues, formState: {  errors } } = useForm<{'chat_img': any, 'chat_room_id': any, 'chat_msg': any}>({defaultValues: {'chat_img': '', 'chat_room_id': '', 'chat_msg': ''}});

  const token = localStorage.getItem('token');
  const post_editor = localStorage.getItem('editor');

  const inputFile = useRef<HTMLInputElement | any>();

  function handleImageChange(e: any) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) return;

    if (!file.type.match('image.*')) {
      toast.error('Please choose an image file.');
      return;
    }

      reader.onloadend = () => {
        let result = reader.result;
        if (typeof result !== 'string') return;

        setFile(file);
        setImagePreviewUrl(result);

        setValue('chat_img', file);
      };

      reader.readAsDataURL(file);
  }

  const onButtonClick = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  useEffect(() => {
    setValue('chat_room_id', land);
  }, [land]);

  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<any | string>(false);
  const [postStatus, setPostStatus] = useState('');
  const [draftStatus, setDraftStatus] = useState('');
  const richEditorRef = useRef<any>(null);
  const lastRichSelectionRef = useRef<any>(null);
  const toolbarPromptActiveRef = useRef(false);
  const lastToolbarPromptAtRef = useRef(0);
  const suppressDraftSaveRef = useRef(false);
  const draftRestoreAttemptedRef = useRef(false);

  const { items, status, sortByTime } = useSelector(selectLounges);

  const [shortByTime, setShortByTime] = useState<any | string>(
    localStorage.getItem('shortByTime')
  );

  const [ advancedpost, setAdvancedPost ] = useState(false);
  const [richtextvalue, onRichTextChange] = useState('');
  const [postAsMwIntelligence, setPostAsMwIntelligence] = useState(false);
  const canPostAsMwIntelligence = isMouseWaitAdminLogin();
  
  useEffect(() => {
    sortByTime != '' && setShortByTime(sortByTime);
  }, [sortByTime]);

  useEffect(() => {
    try {
      if (sessionStorage.getItem('mw_lounge_refresh_to_top') !== 'true') return;
      sessionStorage.removeItem('mw_lounge_refresh_to_top');
    } catch {
      return;
    }

    window.requestAnimationFrame(() => {
      scrollLoungeToTop();
    });
  }, [scrollLoungeToTop]);

  function closeModal() {
    if (isLoading) return;
    suppressDraftSaveRef.current = false;
    draftRestoreAttemptedRef.current = false;
    setLand('7');
    setImagePreviewUrl('');
    setValue('chat_img', '');
    setFile('');
    setValue('chat_msg', '');
    setText('');
    onRichTextChange('');
    setPostAsMwIntelligence(false);
    setPostStatus('');
    setVisible(false);
    setIsOpen(false);
  }

  const clearStoredDraft = useCallback(() => {
    try {
      localStorage.removeItem(DRAFT_STORAGE_KEY);
    } catch {
      // Draft cleanup should never block typing.
    }
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const nextText = event.target.value;
    setText(nextText);

    if (!nextText.trim() && !advancedpost) {
      clearStoredDraft();
      setDraftStatus('');
    }
  };

  useEffect(() => {
    if (!modalIsOpen) {
      draftRestoreAttemptedRef.current = false;
    }
  }, [modalIsOpen]);

  useEffect(() => {
    if (!modalIsOpen) return;
    if (draftRestoreAttemptedRef.current) return;

    const hasCurrentDraft = text.trim() || !isRichTextEmpty(richtextvalue);
    if (hasCurrentDraft) {
      draftRestoreAttemptedRef.current = true;
      return;
    }

    draftRestoreAttemptedRef.current = true;

    try {
      const raw = localStorage.getItem(DRAFT_STORAGE_KEY);
      if (!raw) return;

      const draft = JSON.parse(raw);
      if (draft?.version !== 1) return;
      const lastPublished = normalizeDraftMessage(
        localStorage.getItem(PUBLISHED_DRAFT_STORAGE_KEY) || ''
      );
      const draftMessage = normalizeDraftMessage(getDraftMessage(draft));
      if (draftMessage && lastPublished && draftMessage === lastPublished) {
        localStorage.removeItem(DRAFT_STORAGE_KEY);
        return;
      }

      setAdvancedPost(Boolean(draft.advancedpost));
      setLand(draft.land || '7');
      setText(draft.text || '');
      onRichTextChange(draft.richtextvalue || '');
      if (draft.updatedAt) {
        setDraftStatus('Draft restored');
      }
    } catch {
      // Ignore broken drafts and let the user keep typing.
    }
  }, [modalIsOpen, richtextvalue, text]);

  useEffect(() => {
    if (!modalIsOpen || isLoading) return;

    const hasWritableDraft =
      text.trim() || !isRichTextEmpty(richtextvalue) || String(land) !== '7' || advancedpost;

    if (!hasWritableDraft) {
      setDraftStatus('');
      return;
    }

    setDraftStatus('Saving draft...');
    const timeout = window.setTimeout(() => {
      if (suppressDraftSaveRef.current) return;

      const updatedAt = Date.now();
      try {
        localStorage.setItem(
          DRAFT_STORAGE_KEY,
          JSON.stringify({
            version: 1,
            updatedAt,
            land: String(land),
            advancedpost,
            text,
            richtextvalue,
          })
        );
        setDraftStatus('Draft saved');
      } catch {
        setDraftStatus('Draft not saved');
      }
    }, 450);

    return () => window.clearTimeout(timeout);
  }, [advancedpost, isLoading, land, modalIsOpen, richtextvalue, text]);

  useEffect(() => {
    if (String(land) === '5' || String(land) === '6' || String(land) === '10') {
      setPostAsMwIntelligence(false);
    }
  }, [land]);

  const applySelectedLink = () => {
    const editor = richEditorRef.current?.getEditor?.();
    if (!editor) return;

    const range = editor.getSelection(false) || lastRichSelectionRef.current;
    const selectedText =
      range && range.length > 0
        ? editor.getText(range.index, range.length).trim()
        : '';
    const rawUrl = window.prompt(
      selectedText ? 'Paste the link for the selected words:' : 'Paste the link:'
    );
    if (rawUrl == null) return;

    const url = normalizeUrl(rawUrl);
    if (!url) return;

    if (range && range.length > 0) {
      editor.formatText(range.index, range.length, 'link', url, 'user');
      editor.setSelection(range.index + range.length, 0, 'silent');
    } else {
      const cursor = range?.index ?? editor.getLength();
      editor.insertText(cursor, url, 'link', url, 'user');
      editor.setSelection(cursor + url.length, 0, 'silent');
    }

    const html = editor.root?.innerHTML;
    if (typeof html === 'string') {
      onRichTextChange(html);
    }
  };

  const insertPromptVideo = () => {
    const editor = richEditorRef.current?.getEditor?.();
    if (!editor) return;

    const rawUrl = window.prompt('Paste the video URL:');
    if (rawUrl == null) return;

    const url = normalizeUrl(rawUrl);
    if (!url) return;

    const range = editor.getSelection(false) || lastRichSelectionRef.current;
    const cursor = range?.index ?? editor.getLength();
    editor.insertEmbed(cursor, 'video', url, 'user');
    editor.setSelection(cursor + 1, 0, 'silent');

    const html = editor.root?.innerHTML;
    if (typeof html === 'string') {
      onRichTextChange(html);
    }
  };

  useEffect(() => {
    if (!advancedpost || !modalIsOpen) return;

    const editor = richEditorRef.current?.getEditor?.();
    const onSelectionChange = (range: any) => {
      if (range) {
        lastRichSelectionRef.current = range;
      }
    };
    editor?.on?.('selection-change', onSelectionChange);
    const currentRange = editor?.getSelection?.(false);
    if (currentRange) {
      lastRichSelectionRef.current = currentRange;
    }

    const onToolbarIntent = (event: Event) => {
      const target = event.target as Element | null;
      const button = target?.closest?.(
        '.mw-post-modal .advance-editor .ql-link, .mw-post-modal .advance-editor .ql-video'
      );
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      if ('stopImmediatePropagation' in event) {
        event.stopImmediatePropagation();
      }

      const now = Date.now();
      if (event.type === 'click' && now - lastToolbarPromptAtRef.current < 1000) {
        return;
      }
      if (toolbarPromptActiveRef.current) return;

      toolbarPromptActiveRef.current = true;
      lastToolbarPromptAtRef.current = now;
      if (button.classList.contains('ql-link')) {
        applySelectedLink();
      } else {
        insertPromptVideo();
      }
      window.setTimeout(() => {
        toolbarPromptActiveRef.current = false;
      }, 350);
    };

    const events = ['pointerdown', 'touchstart', 'mousedown', 'click'];
    events.forEach((eventName) => {
      document.addEventListener(eventName, onToolbarIntent, true);
    });

    return () => {
      editor?.off?.('selection-change', onSelectionChange);
      events.forEach((eventName) => {
        document.removeEventListener(eventName, onToolbarIntent, true);
      });
    };
  }, [advancedpost, modalIsOpen]);

  const onPostClick = async () => {
    if (token == null) {
      navigate('/disneyland/login');
      return;
    }
    if (isLoading) return;

    const selectedLand = String(land);
    const isWdwRoom = selectedLand === '5' || selectedLand === '6' || selectedLand === '10';
    const mappedRoomId = isWdwRoom
      ? selectedLand === '10'
        ? '0'
        : String(Number(selectedLand) - 4)
      : selectedLand;

    const selectedImage = !advancedpost ? getValues('chat_img') : '';
    const hasSelectedImage = Boolean(selectedImage);
    const message = advancedpost ? richtextvalue : text;
    const messageTrimmed = typeof message === 'string' ? message.trim() : '';
    if (
      advancedpost
        ? !hasPostableLoungeContent(message, null)
        : !hasPostableLoungeContent(messageTrimmed, selectedImage)
    ) {
      return;
    }
    const data: any = advancedpost
      ? { chat_room_id: mappedRoomId, chat_msg: richtextvalue, chat_img: '' }
      : {
          chat_room_id: mappedRoomId,
          chat_msg: messageTrimmed ? text : ' ',
          chat_img: selectedImage,
        };
    if (!isWdwRoom && postAsMwIntelligence) {
      data.post_as_mw_intelligence = true;
    }

    const draftText = text;
    const draftRichText = richtextvalue;
    const draftImage = selectedImage;
    const draftImagePreview = imagePreviewUrl;
    suppressDraftSaveRef.current = true;
    setIsLoading(true);
    setPostStatus(hasSelectedImage ? 'Uploading photo and posting...' : 'Posting...');
    await writePendingPost({
      isWdw: isWdwRoom,
      chatRoomId: mappedRoomId,
      chatMsg: messageTrimmed,
      expectImage: !advancedpost && hasSelectedImage,
      imagePreviewDataUrl:
        !advancedpost && typeof imagePreviewUrl === 'string'
          ? imagePreviewUrl
          : undefined,
    });

    try {
      const res: any = isWdwRoom
        ? await dispatch<any>(postLoungeWdw(data))
        : await dispatch<any>(postLounge(data));
      const payload = res?.payload?.data;

      if (payload?.sucess != undefined) {
        localStorage.setItem('shortByTime', 'true');
        localStorage.setItem(PUBLISHED_DRAFT_STORAGE_KEY, messageTrimmed);
        localStorage.removeItem(DRAFT_STORAGE_KEY);
        try {
          sessionStorage.removeItem('mw_pending_post_v1');
          window.dispatchEvent(new Event('mw:pending-post'));
        } catch {}
        setPostStatus('Posted. Reloading Lounge...');
        try {
          sessionStorage.setItem('mw_lounge_refresh_to_top', 'true');
        } catch {}

        window.location.href =
          window.location.origin + buildPostedPostFeedHref(isWdwRoom, mappedRoomId);
        return;
      }

      const errorMessage = payload?.message || payload?.error || 'Unable to post right now.';
      toast.error(errorMessage);
      try {
        sessionStorage.removeItem('mw_pending_post_v1');
        window.dispatchEvent(new Event('mw:pending-post'));
      } catch {}
      suppressDraftSaveRef.current = false;
      setIsOpen(true);
      setVisible(true);
      setLand(selectedLand);
      setText(draftText);
      onRichTextChange(draftRichText);
      setValue('chat_img', draftImage);
      setImagePreviewUrl(draftImage ? draftImagePreview : '');
    } catch (error) {
      toast.error('Unable to post right now. Please try again.');
      try {
        sessionStorage.removeItem('mw_pending_post_v1');
        window.dispatchEvent(new Event('mw:pending-post'));
      } catch {}
      suppressDraftSaveRef.current = false;
      setIsOpen(true);
      setVisible(true);
      setLand(selectedLand);
      setText(draftText);
      onRichTextChange(draftRichText);
      setValue('chat_img', draftImage);
      setImagePreviewUrl(draftImage ? draftImagePreview : '');
    } finally {
      setIsLoading(false);
      setPostStatus('');
    }
  };

  const defaultPostReady = hasPostableLoungeContent(text, getValues('chat_img') || file);
  const advancedPostReady = hasPostableLoungeContent(richtextvalue, null);

  return (
    <div>
      <ToastContainer
        position='top-center'
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick={true}
        draggable={false}
        theme='light'
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel='Post to the Lounge'
        className='mw-post-modal'
        overlayClassName='mw-post-modal-overlay'
      >
        <form
          className='mw-post-modal-form space-y-6'
        >
          <div className='row'>
            <div className='box-t-1'>
              <h6>Post to the Lounge</h6>
              <div className='close-p' onClick={closeModal}>
                <i className='fa fa-close my-b' />
              </div>
              <div className='boxwidth'>
                {imagePreviewUrl ? (
                  <img
                    src={imagePreviewUrl}
                    alt='Selected Lounge post preview'
                    style={{ width: 100, height: 100 }}
                  />
                ) : (
                  <p>
                    <br/>Share your Disney pics in the Lounge and earn MouseWait Credits! Just make sure they're family-friendly, and please don't post Googled pictures unless they're related to a news story.<br></br> Thanks for being a part of our magical community! 🏰✨👸
                  </p>
                )}

                {post_editor == 'true' && (
                  <div className="advance-radio-gruop">
                    <div onClick={() => setAdvancedPost(false)}>
                      <input
                        type="radio"
                        id="default"
                        checked={!advancedpost}
                        onChange={() => setAdvancedPost(false)}
                      ></input>
                      <label htmlFor="default">Default Post</label>
                    </div>
                    
                    <div onClick={() => setAdvancedPost(true)}>
                      <input
                        type="radio"
                        id="advanced"
                        checked={advancedpost}
                        onChange={() => setAdvancedPost(true)}
                      ></input>
                      <label htmlFor="advanced">Advanced Post</label>
                    </div>
                  </div>
                )}

                {advancedpost != true ? (
                  <>
                    <div className='plus-p'>
                      <i className='fa fa-plus my-b' onClick={onButtonClick} />

                      <input
                        id='fileinput'
                        ref={inputFile}
                        className='fileInput'
                        type='file'
                        accept='image/*'
                        onChange={(e) => handleImageChange(e)}
                      />
                    </div>

                    <div className='box-ttt'>
                      {/* <label for="story" class="w-50 m-auto justify-content-start">Tell us your story</label> */}
                      <div className='advance-chatmsg'>
                        <textarea
                          rows={3}
                          cols={60}
                          value={text}
                          onChange={handleTextChange}
                          placeholder='write a caption '
                          disabled={isLoading}
                          // {...register('chat_msg')}
                        />
                        <input
                          type='hidden'
                          // setValue={land}
                          {...register('chat_room_id')}
                        />
                        <input
                          type='hidden'
                          // setValue={file}
                          {...register('chat_img')}
                        />
                      </div>
                    </div>
                  </>
                ) : 
                  <>
                    <div className="advance-editor">
                      <RichTextEditor 
                      ref={richEditorRef}
                      value={richtextvalue}
                      onChange={onRichTextChange}
                      controls={DEFAULT_CONTROLS}
                      onImageUpload={handleImageUpload}
                      />
                    </div>
                  </>
                }

                {canPostAsMwIntelligence &&
                  !['5', '6', '10'].includes(String(land)) && (
                    <label className='mw-intelligence-compose-toggle'>
                      <input
                        type='checkbox'
                        checked={postAsMwIntelligence}
                        disabled={isLoading}
                        onChange={(event) =>
                          setPostAsMwIntelligence(event.target.checked)
                        }
                      />
                      <span>Post as Kate (Virtual Plaid)</span>
                    </label>
                  )}

                <div>
                  <div className='box-li'>
                    <ul className='m-0 p-0' style={{ cursor: 'pointer' }}>
                      <li
                        style={land == 7 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('7')}
                      >
                        DISNEYLAND TALK
                      </li>
                      <li
                        style={land == 1 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('1')}
                      >
                        DISNEYLAND REAL-TIME
                      </li>
                      <li
                        style={land == 0 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('0')}
                      >
                        THE HUB{' '}
                      </li>

                      {loungland != '' ? (
                        <li
                          style={
                            land == 3 ? { backgroundColor: '#9BB8EF' } : {}
                          }
                          onClick={() => setLand('3')}
                        >
                          LOUNGE.LAND{' '}
                        </li>
                      ) : (
                        <></>
                      )}

                      {club333 != '' ? (
                        <li
                          style={
                            land == 4 ? { backgroundColor: '#9BB8EF' } : {}
                          }
                          onClick={() => setLand('4')}
                        >
                          CLUB 333{' '}
                        </li>
                      ) : (
                        <></>
                      )}

                      <li
                        style={land == 5 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('5')}
                      >
                        WDW TALK
                      </li>
                      <li
                        style={land == 6 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('6')}
                      >
                        WDW REAL-TIME
                      </li>

                      <li
                        style={land == 10 ? { backgroundColor: '#9BB8EF' } : {}}
                        onClick={() => setLand('10')}
                      >
                        WDW HUB{' '}
                      </li>

                    </ul>
                  </div>
                  <div className='mw-post text-center'>
                    <Link to='/disneyland/lounge'></Link>

                    {isLoading == true ? (
                      <button
                        className='MW-btn mw-post-submit-button'
                        type='button'
                        disabled
                      >
                        <span className='mw-post-submit-spinner' />
                        <span>{postStatus || 'Posting...'}</span>
                      </button>
                    ) : (
                      <>
                        {advancedpost ? (
                          <input className='MW-btn' type='button' value="Post" style={{backgroundColor: !advancedPostReady ? '#d8cccc' : '#0d6efd'}} disabled={!advancedPostReady || isLoading}
                          onClick={onPostClick}
                        />
                        ) : (
                          <input className='MW-btn' type='button' value="Post" style={{backgroundColor: !defaultPostReady ? '#d8cccc' : '#0d6efd'}} disabled={!defaultPostReady || isLoading}
                          onClick={onPostClick}
                        />
                        )}
                      </>                      
                      // <input className='MW-btn' type='button' value="Post" style={{backgroundColor: text == '' ? '#d8cccc' : '#0d6efd'}} disabled={text == '' || isLoading} 
                      // onClick={onPostClick}
                      // />
                    )}
                  </div>
                  {draftStatus && !isLoading ? (
                    <div className='mw-post-draft-status' role='status' aria-live='polite'>
                      {draftStatus}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>

        <li className='nav-item last-li my-link' onClick={openModal}>
          <div className='nav-icon'>
            <img src={Post} className='img-fluid' alt='img' />
            <a style={{ marginLeft: '15px' }} href='#' onClick={(event) => event.preventDefault()}>
              Post to the Lounge
            </a>
          </div>
        </li>
        <div className='mw-floating-actions'>
          <div className='mw-compose-action-wrap'>
            <button
              type='button'
              className='plus-show mw-floating-action mw-floating-action--compose'
              aria-label='Start a Lounge post'
              onClick={openModal}
            >
              <i className='fa fa-plus plus-i' aria-hidden='true'></i>
            </button>
          </div>
        </div>
    </div>
  );
};
